import { Container } from "../../../reducers/componentSearch";
import { Formik } from "formik";
import { FormContainer } from "../../../constants/Styles";
import FormikNumberInput from "../../formik-form-components/FormikNumberInput";
import ContainerFormButtons from "../../component-search/PartDrawer/Inventory/PhysicalInventory/ContainerFormButtons";
import React from "react";
import * as Yup from "yup";
import useUpdateAllocation from "../../../utils/hooks/inventory/updateAllocation";
import { ModalContainer, Title } from "./BoardInventoryStyles";
import { useCustomAlert } from "../../../utils/hooks/alerts";
import AllocationsSummary from "../parts/InventoryUpdates/AllocationsSummary";
import { useBoard } from "../../../utils/hooks/commonly-stored/uploaded-board/board";

interface MarkAllocationAsSpentFormValues {
  qtySpent: number;
}

export default function MarkAllocationAsSpent({
  container,
  quantityAllocatedFromThisContainer,
  boardId,
  shipmentId,
  closeModal,
}: {
  container: Container;
  quantityAllocatedFromThisContainer: number;
  boardId: string;
  shipmentId: string;
  closeModal: () => void;
}) {
  const { board } = useBoard(boardId);
  const customAlert = useCustomAlert();
  const onSuccess = () => {
    closeModal();
  };
  const onError = (detail: string) => {
    customAlert(detail);
  };
  const { markAllocationAsSpent, loading } = useUpdateAllocation(
    onSuccess,
    onError,
  );
  const spendAllocationSchema = Yup.object().shape({
    qtySpent: Yup.number()
      .min(0, "Quantity spent must be greater than zero.")
      .required("Quantity is required"),
  });

  const onSubmit = (values: MarkAllocationAsSpentFormValues) => {
    markAllocationAsSpent({
      flashpcb_container_barcode: container.flashpcb_container_barcode,
      board_id: boardId,
      shipment_id: shipmentId,
      quantity_spent: values.qtySpent,
      quantity_allocated: quantityAllocatedFromThisContainer,
    });
  };

  return (
    <ModalContainer>
      <Title>{`Mark allocation from ${container.flashpcb_container_barcode} as spent for ${board?.project_name}  (${board?.id})`}</Title>
      <Formik
        initialValues={{
          qtySpent: quantityAllocatedFromThisContainer,
        }}
        onSubmit={onSubmit}
        validationSchema={spendAllocationSchema}
      >
        {({ handleSubmit, isValid }) => {
          return (
            <FormContainer onSubmit={handleSubmit}>
              <FormikNumberInput
                name="qtySpent"
                label={"Quantity spent"}
                disabled={false}
                autoFocus={true}
              />
              <ContainerFormButtons
                onCancel={closeModal}
                loading={loading}
                isDisabled={!isValid}
                onSubmit={handleSubmit}
              />
            </FormContainer>
          );
        }}
      </Formik>
      <AllocationsSummary container={container} shipmentId={shipmentId} />
    </ModalContainer>
  );
}
